import React from "react";
import { t } from "i18next";

import { BANNER_BODY } from "../../constant/constant";
import SearchBanner from "./SearchBanner";

function NetworkSearchBanner() {
  return (
    <div>
      <SearchBanner
        title={t("argus-network-search")}
        icon="icon-home"
        content={
          <div>
            {BANNER_BODY &&
              BANNER_BODY.map((content, index) => (
                <p key={index}>{t(content)}</p>
              ))}
          </div>
        }
      />
    </div>
  );
}

export default NetworkSearchBanner;
